module.exports = __webpack_public_path__ + "CSV.png";